import type { OrganizationSetupStepKey } from '@brimo/shared';

/** Route segments of the admin wizard (`/setup/organization/:step`) and their server step keys. */
export const wizardSegments = [
  { segment: 'brand', key: 'brand' },
  { segment: 'company', key: 'company_data' },
  { segment: 'legal-texts', key: 'legal_texts' },
  { segment: 'domain', key: 'domain' },
  { segment: 'telephony', key: 'telephony' },
  { segment: 'team', key: 'team' },
] as const satisfies readonly { segment: string; key: OrganizationSetupStepKey }[];

export type WizardSegment = (typeof wizardSegments)[number]['segment'] | 'security';

export function segmentOf(key: OrganizationSetupStepKey | null): WizardSegment {
  return wizardSegments.find((entry) => entry.key === key)?.segment ?? 'security';
}

export function keyOf(segment: string): OrganizationSetupStepKey | null {
  return wizardSegments.find((entry) => entry.segment === segment)?.key ?? null;
}

export function isWizardSegment(segment: string | undefined): segment is WizardSegment {
  return segment === 'security' || wizardSegments.some((entry) => entry.segment === segment);
}

/** „Schritt 2 von 6". */
export function stepEyebrow(segment: WizardSegment): string {
  const index = wizardSegments.findIndex((entry) => entry.segment === segment);
  return `Schritt ${index + 1} von ${wizardSegments.length}`;
}
